import { useRef, useState } from "react";
import { Accordion, Button, Carousel, Col, Row } from "react-bootstrap";
import { MdArrowBackIos } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import Pricing from "../../components/pricing";
import { PiCurrencyCircleDollar } from "react-icons/pi";
import _ from "lodash";
import { AiOutlineClockCircle } from "react-icons/ai";
import moment from "moment";
import { LuLayoutDashboard } from "react-icons/lu";
import { LiaClipboardListSolid } from "react-icons/lia";
import classNames from "classnames";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { VenuesByStateCard } from "../../components/common/card";
import { TfiLocationPin } from "react-icons/tfi";
import { useInView } from "react-intersection-observer";
import Map from "../../components/map";
import parse from "html-react-parser";
import { marked } from "marked";
import Lightbox from "react-18-image-lightbox";

// Utility Service
import { getCurrencyText } from "../../utils";

const ResponsiveView = (props) => {
    let navigate = useNavigate();
    const swiperRef = useRef(null);
    const swiperFloorPlanRef = useRef(null);
    const [swiperIndex, setSwiperIndex] = useState(0);
    const [swiperFloorPlanIndex, setSwiperFloorPlanIndex] = useState(0);
    const [photoModalShow, setPhotoModalShow] = useState(false);
    const [photoModalIndex, setPhotoModalIndex] = useState(0);

    const { ref, inView } = useInView({
        threshold: 0,
    });

    return (
        <>
            <div className="d-flex align-items-center my-3">
                <MdArrowBackIos
                    role="button"
                    size={26}
                    className="me-2"
                    onClick={() => navigate(-1)}
                />
                <div className="text-center w-100">
                    <h4 className="fw-bold mb-0">{props?.individualData?.name}</h4>
                </div>
            </div>

            <div className="my-3">
                <Carousel className="complexSliderClass" controls={false} variant="primary">
                    {props?.individualData?.images?.length > 0 &&
                        props?.individualData?.images?.map((item, index) => (
                            <Carousel.Item key={index} className="">
                                <div>
                                    <img
                                        className="w-100 h-40vh"
                                        src={item}
                                        alt="complex slider img"
                                    />
                                </div>
                            </Carousel.Item>
                        ))}
                </Carousel>
            </div>

            <Row className="mb-2 mx-0">
                <Col xs={12} className="text-start ps-0">
                    <span className="fs-12 fw-bold text-muted">
                        <TfiLocationPin className="me-1 mb-1" />
                        {props?.individualData?.info?.address}
                    </span>
                </Col>
            </Row>

            <div className="my-3">
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header className="bg-accordionHeader">
                            <span className="fs-18 fw-bold">
                                <PiCurrencyCircleDollar size={24} className="me-1 fw-bold" />
                                Pricing: {getCurrencyText(
                                    props?.individualData?.info?.country
                                )}{" "}
                                {_.min(
                                    props?.individualData?.facilities?.map((item) =>
                                        parseFloat(item?.min_price)
                                    )
                                )}
                                -
                                {_.max(
                                    props?.individualData?.facilities?.map((item) =>
                                        parseFloat(item?.max_price)
                                    )
                                )}{" "}
                                / hour
                            </span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <Pricing individualData={props?.individualData} singleVenue={true} />
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header className="bg-accordionHeader">
                            <span className="fs-18 fw-bold">
                                <AiOutlineClockCircle size={24} className="me-1" />
                                Opening Hours
                            </span>
                        </Accordion.Header>
                        <Accordion.Body>
                            {props?.individualData?.facilities?.length > 0 &&
                                props?.individualData?.facilities?.map((item, index) => (
                                    <p className="fs-12" key={index}>
                                        {item?.name} daily : {item?.opening} -{" "}
                                        {moment(item?.opening, "HH:mm")
                                            .add(item?.no_of_hours, "h")
                                            .format("HH:mm")}
                                    </p>
                                ))}
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header className="bg-accordionHeader">
                            <span className="fs-18 fw-bold">
                                <AiOutlineClockCircle size={24} className="me-1" />
                                Amenities & Facilities
                            </span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <>
                                <div className="mb-3">
                                    <p className="fw-bold">Amenities</p>
                                    <div className="d-flex flex-wrap">
                                        {props?.individualData?.amenities?.length > 0 &&
                                            props?.individualData?.amenities?.map((item, index) => (
                                                <div
                                                    className="d-flex flex-column align-items-center mb-3 me-3"
                                                    key={`amenities${index}`}
                                                >
                                                    <img
                                                        className="rounded-circle bg-dar me-2"
                                                        src={item?.amenity?.images[0]}
                                                        width={20}
                                                        alt="amenity pic"
                                                    />
                                                    <span className="fs-14">
                                                        {item?.amenity?.name}
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                                <div>
                                    <p className="fw-bold">Facilities</p>
                                    {props?.individualData?.facilities?.length > 0 &&
                                        props?.individualData?.facilities?.map((item, index) => (
                                            <p className="fs-14" key={index}>
                                                {item?.name}
                                            </p>
                                        ))}
                                </div>
                            </>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header className="bg-accordionHeader">
                            <span className="fs-18 fw-bold">
                                <LuLayoutDashboard size={24} className="me-1" />
                                Centre Layout
                            </span>
                        </Accordion.Header>
                        <Accordion.Body>
                            {props?.individualData?.info?.floor_plan?.length > 1 ? (
                                <div className="my-3 d-flex align-items-center w-100">
                                    <div className="mb-3">
                                        <IoIosArrowDropleft
                                            role={swiperFloorPlanIndex > 0 ? "button" : ""}
                                            className={classNames("me-2", {
                                                "text-primary": swiperFloorPlanIndex > 0,
                                            })}
                                            color={swiperFloorPlanIndex === 0 ? "grey" : ""}
                                            size={24}
                                            onClick={() => swiperFloorPlanRef.current?.slidePrev()}
                                        />
                                    </div>
                                    <Swiper
                                        className="floor-plan-swiper-slider"
                                        slidesPerView={"auto"}
                                        spaceBetween={0}
                                        modules={[Autoplay]}
                                        autoplay={{
                                            delay: 3000,
                                            disableOnInteraction: false,
                                        }}
                                        onBeforeInit={(swiper) => {
                                            swiperFloorPlanRef.current = swiper;
                                        }}
                                        onReachEnd={(swiper) => {
                                            setSwiperFloorPlanIndex(
                                                props?.individualData?.info?.floor_plan?.length
                                            );
                                        }}
                                        onSlideChange={(swiper) => {
                                            if (swiper.isEnd) {
                                                setSwiperFloorPlanIndex(
                                                    props?.individualData?.info?.floor_plan?.length
                                                );
                                            } else {
                                                setSwiperFloorPlanIndex(swiper?.activeIndex);
                                            }
                                        }}
                                    >
                                        {props?.individualData?.info?.floor_plan?.map(
                                            (item, index) => {
                                                return (
                                                    <SwiperSlide key={`floor-plan-${index}`}>
                                                        <div
                                                            className={classNames(
                                                                "rounded-4 h-100"
                                                            )}
                                                            role="button"
                                                        >
                                                            <img
                                                                className="img-fluid w-100"
                                                                src={item}
                                                                alt="floor_plan"
                                                                role="button"
                                                                onClick={() => {
                                                                    setPhotoModalShow(true);
                                                                    setPhotoModalIndex(index);
                                                                }}
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                );
                                            }
                                        )}
                                    </Swiper>
                                    <div className="ms-3 mb-3">
                                        <IoIosArrowDropright
                                            role={
                                                swiperFloorPlanIndex <
                                                    props?.individualData?.info?.floor_plan?.length
                                                    ? "button"
                                                    : ""
                                            }
                                            className={classNames({
                                                "text-primary":
                                                    swiperFloorPlanIndex <
                                                    props?.individualData?.info?.floor_plan?.length,
                                            })}
                                            color={
                                                swiperFloorPlanIndex ===
                                                    props?.individualData?.info?.floor_plan?.length
                                                    ? "grey"
                                                    : ""
                                            }
                                            size={24}
                                            onClick={() => swiperFloorPlanRef.current?.slideNext()}
                                        />
                                    </div>

                                    {photoModalShow && (
                                        <Lightbox
                                            mainSrc={
                                                props?.individualData?.info?.floor_plan[
                                                photoModalIndex
                                                ]
                                            }
                                            nextSrc={
                                                props?.individualData?.info?.floor_plan[
                                                (photoModalIndex + 1) %
                                                props?.individualData?.info?.floor_plan
                                                    .length
                                                ]
                                            }
                                            prevSrc={
                                                props?.individualData?.info?.floor_plan[
                                                (photoModalIndex +
                                                    props?.individualData?.info?.floor_plan
                                                        .length -
                                                    1) %
                                                props?.individualData?.info?.floor_plan
                                                    .length
                                                ]
                                            }
                                            onMovePrevRequest={() =>
                                                setPhotoModalIndex(
                                                    (photoModalIndex +
                                                        props?.individualData?.info?.floor_plan
                                                            .length -
                                                        1) %
                                                    props?.individualData?.info?.floor_plan
                                                        .length
                                                )
                                            }
                                            onMoveNextRequest={() =>
                                                setPhotoModalIndex(
                                                    (photoModalIndex + 1) %
                                                    props?.individualData?.info?.floor_plan
                                                        .length
                                                )
                                            }
                                            onCloseRequest={() => {
                                                setPhotoModalShow(false);
                                                setPhotoModalIndex(0);
                                            }}
                                        />
                                    )}
                                </div>
                            ) : (
                                <div>
                                    <img
                                        width="100%"
                                        className="mt-3"
                                        src={props?.individualData?.info?.floor_plan[0]}
                                        alt="floor_plan"
                                    />
                                </div>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header className="bg-accordionHeader">
                            <span className="fs-18 fw-bold">
                                <LiaClipboardListSolid size={24} className="me-1" />
                                Centre Policy
                            </span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="center-policy mt-3">
                                {props?.individualData?.info?.center_policy
                                    ? parse(marked(props?.individualData?.info?.center_policy))
                                    : ""}
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>

            <Row className="my-3 mx-0 ">
                <hr />
                <p className="fs-18 fw-bold">Location of Complex</p>
                <span className="fs-16">
                    <TfiLocationPin className="me-1 mb-1" />
                    {props?.individualData?.info?.address}
                </span>
                {props?.individualData?.location_lat && props?.individualData?.location_long && (
                    <div className="mt-3 mb-3">
                        <Map
                            lat={props?.individualData?.location_lat}
                            lng={props?.individualData?.location_long}
                        />
                    </div>
                )}
            </Row>

            <div ref={ref} className="mt-1 mb-3 px- mx-0 ">
                <div
                    className={classNames("", {
                        "d-none": !inView,
                        "z-2": inView,
                    })}
                >
                    <Link
                        to={`${process.env.REACT_APP_BOOKING_URL}/?auth=${props?.individualData?.id}`}
                        onClick={() => {
                            ReactGA.event("contact_initiated", {
                                category: "contact_initiated",
                                action: JSON.stringify({
                                    id: props?.individualData?.id,
                                    name: props?.individualData?.name,
                                }),
                            });
                        }}
                    >
                        <Button className={"text-light mb-3 w-100"} variant={"primary"}>
                            Book Venue
                        </Button>
                    </Link>
                </div>

                <div
                    className={classNames("px-5 text-center", {
                        "z-2 fixed-bottom": !inView,
                        "d-none": inView,
                    })}
                >
                    <Link
                        to={`${process.env.REACT_APP_BOOKING_URL}/?auth=${props?.individualData?.id}`}
                        onClick={() => {
                            ReactGA.event("contact_initiated", {
                                category: "contact_initiated",
                                action: JSON.stringify({
                                    id: props?.individualData?.id,
                                    name: props?.individualData?.name,
                                }),
                            });
                        }}
                    >
                        <Button className={"text-light w-100"} variant={"primary"}>
                            Book Venue
                        </Button>
                    </Link>
                </div>
                <h4 className="fw-bold">Venues Nearby</h4>
                <div className="mt-3 d-flex align-items-center mb-5">
                    <div className="mb-3">
                        <IoIosArrowDropleft
                            role={swiperIndex > 0 ? "button" : ""}
                            className={classNames("me-2", {
                                "text-primary": swiperIndex > 0,
                            })}
                            color={swiperIndex === 0 ? "grey" : ""}
                            size={24}
                            onClick={() => swiperRef.current?.slidePrev()}
                        />
                    </div>
                    <Swiper
                        className="venue-swiper-slider"
                        slidesPerView={"auto"}
                        spaceBetween={10}
                        onBeforeInit={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        onReachEnd={(swiper) => {
                            setSwiperIndex(props?.nearbyVenue?.length);
                        }}
                        onSlideChange={(swiper) => {
                            setSwiperIndex(swiper?.activeIndex);
                        }}
                    >
                        {props?.nearbyVenue?.length > 0 &&
                            props?.nearbyVenue?.map((item, index) => {
                                return (
                                    <SwiperSlide key={`venue${index}`}>
                                        <div
                                            key={index}
                                            className={classNames("me-3 rounded-4 px-3 py-1 h-100")}
                                            role="button"
                                        // onClick={() => stateSelection(item)}
                                        >
                                            <VenuesByStateCard item={item} nearBy={true} />
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                    </Swiper>
                    <div className="ms-3 mb-3">
                        <IoIosArrowDropright
                            role={swiperIndex < props?.nearbyVenue?.length ? "button" : ""}
                            className={classNames({
                                "text-primary": swiperIndex < props?.nearbyVenue?.length,
                            })}
                            color={swiperIndex === props?.nearbyVenue?.length ? "grey" : ""}
                            size={24}
                            onClick={() => swiperRef.current?.slideNext()}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResponsiveView;
